import { useAuthenticator } from "@aws-amplify/ui-react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { syncAmplifyReduxUserAttributes } from "../../services/authorization/thunks";
import { selectAuthenticatedUserSessionID } from "../../services/authorization/slices";

const useAuthenticationSync = () => {
  const { user, authStatus } = useAuthenticator((state) => [state?.user?.userId]);
  const dispatch = useDispatch();
  const allowRefresh = useSelector((state) => {
    const currentAuthenticatedSubId = user?.userId;
    const currentReduxUserID = selectAuthenticatedUserSessionID(state);
    return Boolean(
      currentAuthenticatedSubId &&
      authStatus === "authenticated" &&
      currentAuthenticatedSubId !== currentReduxUserID
    );
  });

  useEffect(() => {
    if (allowRefresh) {
      dispatch(syncAmplifyReduxUserAttributes());
    }
  }, [dispatch, allowRefresh]);

}; 

export default useAuthenticationSync;
